import React from 'react';
import "../../css/dashboardStylings/DashboardGardeningTipsStyling.css";

const DashboardGardeningTipsComponent = () => {
    return (
        <div className={`dashboard-gardening-tips-body`}>
            <div className="construction-message">
                <div>🚧 This component is under construction! 🚧</div>
                <div className="construction-subtitle">We're working hard to bring you something amazing.</div>
            </div>
        </div>
    )
}

export default DashboardGardeningTipsComponent;